var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('section',_vm._l((_vm.activeMenu),function(m,idx){return _c('home-item',{key:`${m.item.name}_${idx}`,attrs:{"menu":m,"iconStyle":_vm.getIconStyle(m)}})}),1),_c('inject',{attrs:{"name":"agreement-management"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }